import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2669709893/src/mila_me_frontend_customer/app/[locale]/blogs/[id]/BlogArticleClient.tsx");
